


















































































































































































































































































































































































































































































































































































































































































































































































































































import DynamicColumnChart from '@/charts/DynamicColumnChart_.vue';
import DynamicLineChart from '@/charts/DynamicLineChart_.vue';
import CustomLineChart from '@/charts/CustomLineChart.vue';
import CustomBarChart from '@/charts/CustomBarChart.vue';
import CustomCircleChart from '@/charts/CustomCircleChart.vue';
import deck from '@/store/modules/deck';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Chart } from 'highcharts-vue';
import ProfitLoss from '@/charts/ProfitLoss_.vue';
import Balance from '@/charts/BalanceGT_.vue';
import CashflowV2 from '@/charts/CashFlow_v2_.vue';
import Compass_ from '@/components/Compass_.vue';
import PDF from '@/components/simpleSlide/components/PDF.vue';
import {blobSlideSrc} from '@/utils/blobSlideSrc';
import ContentSubject from '@/components/simpleSlide/components/ContentSubject.vue';
import HelpPanel from '@/components/simpleSlide/components/HelpPanel.vue';
import user from '@/store/modules/user';
import Schedule from '@/components/simpleSlide/components/Schedule.vue';
import SustainabilityCompass from '@/charts/SustainabilityCompassCqw.vue';
import CompassIndustry from '@/components/CompassIndustryCqw.vue';
import CompassCompetitors from '@/components/CompassCompetitorsCqw.vue';
import ProfitLossTable from '@/components/ProfitLossTable_.vue';
import BalanceTable from '@/components/BalanceTable_.vue';
import CashflowTable from '@/components/CashflowTable_.vue';
import YearWheel from '@/components/YearWheel.vue';
import OrgChart from '@/components/OrgChart.vue';
import Datepicker from 'vuejs-datepicker';
import { sv } from 'vuejs-datepicker/dist/locale';
import ServiceTree from '@/components/ServiceTree.vue';
import ContentTree from '@/components/ContentTree.vue';
import NextStepsSlide from '@/components/simpleSlide/components/NextStepsSlide.vue';
import YearWheelEditor from '@/components/simpleSlide/components/YearWheelEditor.vue';
import Team from '@/components/simpleSlide/components/Team.vue';
import AiInsights from '@/components/simpleSlide/components/AiInsights.vue';
import { chartType as resolveChartType } from '@/components/simpleSlide/chartType';
import { resolveMentionHtml } from '@/components/simpleSlide/financialMentions';
interface ResizeObserverSize {
  inlineSize: number;
  blockSize: number;
}

interface ResizeObserverEntry {
  target: Element;
  contentRect: DOMRectReadOnly;
  borderBoxSize: ResizeObserverSize[];
  contentBoxSize: ResizeObserverSize[];
}

declare class ResizeObserver {
  constructor(
    callback: (
      entries: ResizeObserverEntry[],
      observer: ResizeObserver,
    ) => void,
  );
  observe(target: Element, options?: ResizeObserverOptions): void;
  unobserve(target: Element): void;
  disconnect(): void;
}

interface ResizeObserverOptions {
  box?: 'content-box' | 'border-box';
}

@Component({
  components: {
    YearWheel,
    ProfitLossTable,
    BalanceTable,
    CashflowTable,
    SustainabilityCompass,
    Schedule,
    PDF,
    DynamicColumnChart,
    DynamicLineChart,
    CustomLineChart,
    CustomBarChart,
    CustomCircleChart,
    Chart,
    ProfitLoss,
    Balance,
    CashflowV2,
    Compass_,
    ContentSubject,
    HelpPanel,
    Datepicker,
    CompassIndustry,
    CompassCompetitors,
    ServiceTree,
    ContentTree,
    NextStepsSlide,
    YearWheelEditor,
    OrgChart,
    Team,
    AiInsights,
  },
})
export default class ShowSlides extends Vue {
  @Prop({ default: 'presentation' }) readonly mode!: string;

  @Prop({ default: undefined }) readonly showComments!: boolean;

  resizeObserver: ResizeObserver | null = null;
  splitBoxResizeObserver: ResizeObserver | null = null;
  containerWidth: number = 1920;
  chartContainerWidths: Record<string, number> = {};

  version: number = 0;

  nav: any[] = [];
  activeLiability: number = 0;

  editable: boolean = false;
  open: boolean = false;
  helpPanelOpen: boolean = false;
  helpPanelContent: any = null;

  touchStartY: number = 0;
  editingOrgChart: boolean = false;
  private lastScrolledSlide: number = -1;

  created() {
    if (this.mode === 'preview') {
      return;
    }
    const blobId = this.$route.params.DocumentId;
    const internal = this.isPrint;
    const shared = this.$route.path.indexOf('/shared/') !== -1;
    if (shared) {
      deck
        .loadShared({ blobId })
        .then(() => {
          this.nav = Array(deck.Slides.length).fill([0, null]);
        })
        .catch(() => {
          this.$router.push({ name: 'documents' });
        });
    } else {
      deck
        .loadFull({ blobId, internal, editable: this.mode !== 'presentation' })
        .then(() => {
          this.nav = Array(deck.Slides.length).fill([0, null]);
        });
    }
    window.addEventListener('keyup', this.handleKey);
  }

  destroyed() {
    window.removeEventListener('keyup', this.handleKey);
  }

  mounted() {
    this.resizeObserver = new ResizeObserver(() => {
      this.handleResize();
    });
    const target = this.$refs.resizeTarget as Element;
    if (target) {
      this.resizeObserver.observe(target);
    }
    window.addEventListener('touchstart', this.handleTouchStart, {
      passive: false,
    });
    window.addEventListener('touchend', this.handleTouchEnd, {
      passive: false,
    });
    this.handleResize();
    this.$nextTick(() => {
      this.measureSplitChartContainerWidths();
      this.observeSplitBoxes();
    });
  }

  updated() {
    if (this.mode === 'preview' && this.currentSlide !== this.lastScrolledSlide) {
      this.scrollIntoView();
    }
    this.$nextTick(() => {
      this.measureSplitChartContainerWidths();
      this.observeSplitBoxes();
    });
  }

  beforeDestroy() {
    if (this.splitBoxResizeObserver) {
      this.splitBoxResizeObserver.disconnect();
      this.splitBoxResizeObserver = null;
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    window.removeEventListener('touchstart', this.handleTouchStart);
    window.removeEventListener('touchend', this.handleTouchEnd);
  }

  handleResize() {
    this.setAspectratio();
    this.setContainerWidth();
    this.$nextTick(() => {
      this.measureSplitChartContainerWidths();
      this.observeSplitBoxes();
    });
    this.scrollIntoView();
    this.focusFirst();
  }

  getTabIndices(slide: any): number[] {
    if (!slide) {
      return [];
    }
    if (slide.slideType === 'contentLiability') {
      return [0, 1];
    }
    if (slide.slideType === 'slideContent' && slide.subSlides) {
      return slide.subSlides.reduce(
        (indices: number[], sub: any, j: number) => {
          if (sub.contentType) {
            indices.push(j);
          }
          return indices;
        },
        [],
      );
    }
    return [];
  }

  handleTabKey(direction: 'left' | 'right') {
    const slideIndex = deck.nav.currentSlide - 1;
    const slide = deck.Slides[slideIndex];
    const tabIndices = this.getTabIndices(slide);
    if (tabIndices.length < 2) {
      return;
    }
    const current = this.getCurrentSubSlide(slideIndex);
    const pos = tabIndices.indexOf(current);
    if (pos === -1) {
      this.setCurrentSubSlide(tabIndices[0]);
      return;
    }
    if (direction === 'left' && pos > 0) {
      this.setCurrentSubSlide(tabIndices[pos - 1]);
    } else if (direction === 'right' && pos < tabIndices.length - 1) {
      this.setCurrentSubSlide(tabIndices[pos + 1]);
    }
  }

  handleKey(event: any) {
    const target = event.target as HTMLElement | null;
    if (
      target &&
      (target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable)
    ) {
      return;
    }
    if (event.key === 'ArrowLeft') {
      this.handleTabKey('left');
      return;
    }
    if (event.key === 'ArrowRight') {
      this.handleTabKey('right');
      return;
    }
    if (event.key === 'ArrowUp') {
      if (deck.nav.currentSlide === 1) {
        return;
      }
      deck.setCurrentSlide(deck.nav.currentSlide - 1);
    } else if (event.key === 'ArrowDown') {
      if (deck.nav.currentSlide === deck.Slides.length) {
        return;
      }
      deck.setCurrentSlide(deck.nav.currentSlide + 1);
    }
  }

  setCurrentSubSlide(i: number) {
    deck.setCurrentSubSlide(i);
    this.nav[deck.nav.currentSlide - 1] = [i, null];
    this.nav.push([-1, null]);
  }

  getCurrentSubSlide(i: number) {
    if (this.mode !== 'preview') {
      if (!this.nav[i]) {
        return 0;
      }
      return this.nav[i][0];
    }
    if (deck.nav.currentSlide !== i + 1) {
      return 0;
    }
    return deck.nav.currentSubSlide;
  }

  subSlide(slide: any, i: number) {
    if (!slide.subSlides) {
      return undefined;
    }
    if (slide.slideType === 'slideFullContent') {
      return slide.subSlides[0];
    }
    return slide.subSlides[this.getCurrentSubSlide(i)];
  }

  contentTreeSelectedNodeIds(subSlide: any): string[] | undefined {
    if (!subSlide || !Object.prototype.hasOwnProperty.call(subSlide, 'selectedNodeIds')) {
      return undefined;
    }
    return subSlide.selectedNodeIds;
  }

  boxIndexes(slide: any, slideIndex: number): number[] {
    if (!slide || !slide.subSlides) {
      return [0];
    }
    if (slide.slideType === 'splitContent') {
      return [0, 1];
    }
    if (slide.slideType === 'slideFullContent') {
      return [0];
    }
    return [this.getCurrentSubSlide(slideIndex)];
  }


  get isShared() {
    const route = this.$router.currentRoute.name;
    if (!route) {
      return false;
    }
    return route.startsWith('presentation-shared');
  }

  get isLoading() {
    return deck.isLoading;
  }

  get slides() {
    if (this.isPrint) {
      this.nav = [];
      const slides = [];

      const addComment = (comment: string) => {
        const commentSlide = {
          slideType: 'slideContent',
          subSlides: [
            {
              contentType: 'contentText',
              description: 'Mötesanteckningar',
              text: comment,
            },
          ],
        };
        slides.push(commentSlide);
        this.nav.push([0, null]);
      };

      for (const slide of deck.Slides) {
        if (slide.slideType === 'slideContent') {
          let j = 0;
          for (const subSlide of slide.subSlides) {
            if (subSlide.description) {
              slides.push(slide);
              this.nav.push([j, null]);

              let k = 0;
              if (subSlide.subjects && subSlide.subjects.length > 1) {
                for (const subject of subSlide.subjects) {
                  slides.push(slide);
                  this.nav.push([j, k]);
                  k++;
                }
              }

              j++;
            }

            if (subSlide.comment) {
              addComment(subSlide.comment);
              j++;
            }
          }
        } else if (slide.slideType === 'contentLiability') {
          slides.push(slide);
          this.nav.push([0, null]);
          slides.push(slide);
          this.nav.push([1, null]);
        } else {
          slides.push(slide);
          this.nav.push([0, null]);
        }

        if (slide.comment) {
          addComment(slide.comment);
        }
      }

      if (this.hasPdfs > 0) {
        const attachmentDividerSlide = {
          slideType: 'slideHeadline',
          title:
            (this.currentLanguage === 'en' ? 'Attachments' : 'Bilagor') +
            ' (' +
            this.hasPdfs +
            ')',
        };
        slides.push(attachmentDividerSlide);
        this.nav.push([0, null]);
      }

      return slides;
    } else {
      if (this.mode === 'preview') {
        this.nav = Array(deck.Slides.length).fill([0, null]);
      }
    }
    return deck.Slides;
  }

  get hasPdfs() {
    let count = 0;
    for (const slide of deck.Slides) {
      if (slide.subSlides) {
        for (const subSlide of slide.subSlides) {
          if (subSlide.contentType === 'contentPdf') {
            count++;
          }
        }
      }
    }
    return count;
  }

  get currentLanguage() {
    return deck.Language;
  }

  get currentSlide() {
    return deck.nav.currentSlide;
  }

  resolveSlideHtml(text: string, version?: number, subSlide?: any): string {
    let data: any = null;
    if (subSlide) {
      data = this.getCompany(version || 0, subSlide) || null;
    } else if (deck.OrgNr && deck.OrgNr !== '00' && this.companyData[deck.OrgNr]) {
      data =
        this.companyData[deck.OrgNr][deck.SieAggVersion] ||
        this.companyData[deck.OrgNr][0] ||
        null;
    }
    return resolveMentionHtml(text, data);
  }

  getCompany(version: number, subSlide: any) {
    if (!subSlide) {
      return undefined;
    }
    let data;
    if (subSlide.OrgNr) {
      if (!this.companyData[subSlide.OrgNr]) {
        return undefined;
      }
      data = JSON.parse(
        JSON.stringify(
          this.companyData[subSlide.OrgNr][subSlide.SieAggVersion],
        ),
      );
    } else if (!this.companyData[deck.OrgNr]) {
      return undefined;
    }
    if (!data) {
      data = JSON.parse(
        JSON.stringify(this.companyData[deck.OrgNr][deck.SieAggVersion]),
      );
    }
    if (subSlide.Branch && !this.isLoading) {
      const industry = deck.IndustryData[subSlide.Branch];
      if (industry) {
        for (const sheet of data.ranking.sheets) {
          sheet.industryKeyValues = industry.industryKeyValues;
          sheet.industryKeyValues25 = industry.industryKeyValues25;
          sheet.industryKeyValues75 = industry.industryKeyValues75;
          sheet.industryRanks = industry.industryRanks;
          sheet.industryRanks25 = industry.industryRanks25;
          sheet.industryRanks75 = industry.industryRanks75;
        }
      }
    }
    return data;
  }

  getRankings(version: number, subSlide: any) {
    const rankings = [this.getCompany(version, subSlide).ranking];
    if (subSlide.competitor1) {
      if (deck.Data[subSlide.competitor1]) {
        rankings.push(deck.Data[subSlide.competitor1][0].ranking);
      } else {
        rankings.push(undefined);
      }
    }
    if (subSlide.competitor2) {
      if (deck.Data[subSlide.competitor2]) {
        rankings.push(deck.Data[subSlide.competitor2][0].ranking);
      } else {
        rankings.push(undefined);
      }
    }
    return rankings;
  }

  getOverviews(version: number, subSlide: any) {
    const overviews = [this.getCompany(version, subSlide).overview];
    if (subSlide.competitor1 && deck.Data[subSlide.competitor1]) {
      overviews.push(deck.Data[subSlide.competitor1][0].overview);
    }
    if (subSlide.competitor2 && deck.Data[subSlide.competitor2]) {
      overviews.push(deck.Data[subSlide.competitor2][0].overview);
    }
    return overviews;
  }

  get companyData() {
    return deck.Data;
  }

  blobSrc(blobId: string) {
    return blobSlideSrc(
      this.$router.currentRoute.name,
      this.$route.params.DocumentId,
      blobId,
    );
  }

  staticSrc(type: string) {
    switch (type) {
      case 'qbis_start':
        return '/static/gt/image/produktblad/qbis_start.png';
      case 'qbis_time':
        return '/static/gt/image/produktblad/qbis_time.png';
      case 'qbis_project':
        return '/static/gt/image/produktblad/qbis_project.png';
      case 'qbis_expense':
        return '/static/gt/image/produktblad/qbis_expense.png';
      case 'gt_about_us':
        return '/static/gt/image/produktblad/gt_about_us.png';
      case 'gt_our_customers':
        return '/static/gt/image/produktblad/gt_our_customers.png';
      case 'klimat_oversikt':
        return '/static/gt/image/produktblad/klimat_oversikt.png';
      case 'klimat_oversikt_en':
        return '/static/gt/image/produktblad/klimat_oversikt_en.png';
      case 'klimat_enkel':
        return '/static/gt/image/produktblad/klimat_enkel.png';
      case 'klimat_enkel_en':
        return '/static/gt/image/produktblad/klimat_enkel_en.png';
      case 'klimat_utokad':
        return '/static/gt/image/produktblad/klimat_utokad.png';
      case 'klimat_utokad_en':
        return '/static/gt/image/produktblad/klimat_utokad_en.png';
      case 'esg_kundundersokning':
        return '/static/gt/image/produktblad/esg_kundundersokning.png';
      case 'esg_kundundersokning_en':
        return '/static/gt/image/produktblad/esg_kundundersokning_en.png';
      case 'esg_csrd_reglemente':
        return '/static/gt/image/produktblad/esg_csrd_reglemente.png';
      case 'esg_csrd_reglemente_en':
        return '/static/gt/image/produktblad/esg_csrd_reglemente_en.png';
      case 'esg_esrs':
        return '/static/gt/image/produktblad/esg_esrs.png';
      case 'esg_esrs_en':
        return '/static/gt/image/produktblad/esg_esrs_en.png';
      case 'esg_esrs_standard':
        return '/static/gt/image/produktblad/esg_esrs_standard.png';
      case 'esg_esrs_standard_en':
        return '/static/gt/image/produktblad/esg_esrs_standard_en.png';
      case 'esg_our_services':
        return '/static/gt/image/produktblad/esg_our_services.png';
      case 'esg_our_services_en':
        return '/static/gt/image/produktblad/esg_our_services_en.png';
      case 'gt_scopes':
        return '/static/gt/image/produktblad/gt_scopes.png';
      case 'gt_scopes_en':
        return '/static/gt/image/produktblad/gt_scopes_en.png';
      case 'gt_huset':
        return '/static/gt/image/produktblad/gt_huset.png';
      case 'gt_huset_en':
        return '/static/gt/image/produktblad/gt_huset_en.png';
      case 'gt_vision':
        return '/static/gt/image/produktblad/gt_vision.png';
      case 'gt_vision_en':
        return '/static/gt/image/produktblad/gt_vision_en.png';
      case 'radgivare_aktivtstyrelsearbete':
        return '/static/gt/image/produktblad/radgivare_aktivtstyrelsearbete.png';
      case 'radgivare_budgetprocess':
        return '/static/gt/image/produktblad/radgivare_budgetprocess.png';
      case 'radgivare_cfocoach':
        return '/static/gt/image/produktblad/radgivare_cfocoach.png';
      case 'radgivare_hallbarhetsarbete':
        return '/static/gt/image/produktblad/radgivare_hallbarhetsarbete.png';
      case 'radgivare_vardesimulering':
        return '/static/gt/image/produktblad/radgivare_vardesimulering.png';
      case 'radgivare_agardirektiv':
        return '/static/gt/image/produktblad/radgivare_agardirektiv.png';
      case '2406_GT_bridge':
        return '/static/gt/pdf/2406_GT_bridge.pdf';
      case '2406_GT_bridge_en':
        return '/static/gt/pdf/2406_GT_bridge_en.pdf';
      case '2408_GT_klimatnyckeltal':
        return '/static/gt/pdf/2408_GT_klimatnyckeltal.pdf';
      case 'gt_arsredovisning_2024':
        return '/static/gt/pdf/gt_arsredovisning_2024.pdf';
      case 'avr_agardirektiv':
        return '/static/gt/image/produktblad/avr_agardirektiv.png';
      case 'avr_aktivt_styrelsearbete':
        return '/static/gt/image/produktblad/avr_aktivt_styrelsearbete.png';
      case 'avr_avdragsratt':
        return '/static/gt/image/produktblad/avr_avdragsratt.png';
      case 'avr_csrd':
        return '/static/gt/image/produktblad/avr_csrd.png';
      case 'avr_cybersakerhetslag':
        return '/static/gt/image/produktblad/avr_cybersakerhetslag.png';
      case 'avr_esg_modell':
        return '/static/gt/image/produktblad/avr_esg_modell.png';
      case 'avr_fel_moms':
        return '/static/gt/image/produktblad/avr_fel_moms.png';
      case 'avr_hallbarhetskrav':
        return '/static/gt/image/produktblad/avr_hallbarhetskrav.png';
      case 'avr_kompetensutveckling':
        return '/static/gt/image/produktblad/avr_kompetensutveckling.png';
      case 'avr_levkedja':
        return '/static/gt/image/produktblad/avr_levkedja.png';
      case 'avr_minska_klimat':
        return '/static/gt/image/produktblad/avr_minska_klimat.png';
      case 'avr_steget_mot_borsen':
        return '/static/gt/image/produktblad/avr_steget_mot_borsen.png';
      case 'avr_visselblasarlag':
        return '/static/gt/image/produktblad/avr_visselblasarlag.png';
      case 'reporting':
        return '/static/gt/image/produktblad/reporting.png';
      case 'reporting_en':
        return '/static/gt/image/produktblad/reporting_en.png';
      case 'reporting_screenshot':
        return '/static/gt/image/produktblad/reporting_screenshot.png';
      case 'system_support':
        return '/static/gt/image/produktblad/system_support.png';
      case '250922_Klimatnyckeltal':
        return '/static/gt/image/produktblad/250922_Klimatnyckeltal.png';
      case '250922_Klimatnyckeltal_EN':
        return '/static/gt/image/produktblad/250922_Klimatnyckeltal_EN.png';
      case '250922_Klimatnyckeltal_utokad':
        return '/static/gt/image/produktblad/250922_Klimatnyckeltal_utokad.png';
      case '250922_Klimatnyckeltal_utokad_EN':
        return '/static/gt/image/produktblad/250922_Klimatnyckeltal_utokad_EN.png';
      case '250922_Sociala_nyckeltal':
        return '/static/gt/image/produktblad/250922_Sociala_nyckeltal.png';
      case '250922_Sociala_nyckeltal_EN':
        return '/static/gt/image/produktblad/250922_Sociala_nyckeltal_EN.png';
      case '250922_Var_metod':
        return '/static/gt/image/produktblad/250922_Var_metod.png';
      case '250922_Var_metod_EN':
        return '/static/gt/image/produktblad/250922_Var_metod_EN.png';
      case '250922_VSME':
        return '/static/gt/image/produktblad/250922_VSME.png';
      case '250922_ESRS':
        return '/static/gt/image/produktblad/250922_ESRS.png';
      case '250922_ESRS_EN':
        return '/static/gt/image/produktblad/250922_ESRS_EN.png';
      case 'gt_arsredovisning_2025':
        return '/static/gt/pdf/gt_arsredovisning_2025.pdf';
      case '250922_Vardekedja':
        return '/static/gt/image/produktblad/250922_Vardekedja.png';
      case '250922_Vardekedja_EN':
        return '/static/gt/image/produktblad/250922_Vardekedja_EN.png';
      case '250922_Hallbarhetspyramid':
        return '/static/gt/image/produktblad/250922_Hallbarhetspyramid.png';
      case '250930_Klimatnyckeltal_utokad':
        return '/static/gt/image/produktblad/250930_Klimatnyckeltal_utokad.png';
      case '250930_Klimatnyckeltal_utokad_EN':
        return '/static/gt/image/produktblad/250930_Klimatnyckeltal_utokad_EN.png';
      case '251027_Uppdateringar_K2':
        return '/static/gt/image/produktblad/251027_Uppdateringar_K2.png';
      case '251027_Ej_K2_Foretag':
        return '/static/gt/image/produktblad/251027_Ej_K2_Foretag.png';
      case '251027_Ej_K2_Mindre_Foretag':
        return '/static/gt/image/produktblad/251027_Ej_K2_Mindre_Foretag.png';
      case '251027_Uppdateringar_K3':
        return '/static/gt/image/produktblad/251027_Uppdateringar_K3.png';
      case '251027_Byt_K2_K3':
      // case '250922_Hallbarhetspyramid_EN':
      //   return '/static/gt/image/produktblad/250922_Hallbarhetspyramid_EN.png';
    }
    return '';
  }

  setAspectratio() {
    const screenwidth = screen.width;
    const screenheight = screen.height;
    const aspectratio = screenwidth / screenheight;

    const p = document.getElementById('presentation');
    if (!p) {
      return;
    }

    if (this.mode === 'preview') {
      p.style.width = 'calc(25vw + 0.75rem)';
      p.style.height = 'calc((25vw + 0.75rem) / 16 * 9)';
    } else if (this.mode === 'template') {
      p.style.width = '20vw';
      p.style.height = 'calc(20vw / 16 * 9)';
    } else if (aspectratio > 16 / 9) {
      p.style.height = '100%';
      p.style.width = 'calc(100vh / 9 * 16)';
    } else {
      p.style.width = '100%';
      p.style.height = 'calc(100vw / 16 * 9)';
    }
  }

  setContainerWidth() {
    const container = document.getElementById('presentation');
    if (!container) {
      return;
    }
    const containerWidth = container.clientWidth;
    this.containerWidth = containerWidth;
  }

  splitChartWidthFallback(): number {
    return Math.max(1, Math.round(this.containerWidth * 0.47));
  }

  compassSlideLayout(slide: any): 'full' | 'split' | 'auto' {
    if (slide.slideType === 'slideFullContent') {
      return 'full';
    }
    if (slide.slideType === 'splitContent') {
      return 'split';
    }
    return 'auto';
  }

  isBolagsCompassChart(slide: any, boxIndex: number): boolean {
    const sub = slide.subSlides && slide.subSlides[boxIndex];
    if (!sub || sub.contentType !== 'contentChart') {
      return false;
    }
    const type = this.chartType(sub.chart);
    return (
      type === 'Compass' ||
      type === 'IndustryCompass' ||
      type === 'CompetitorsCompass'
    );
  }

  chartContainerWidth(slide: any, slideIndex: number, boxIndex: number): number {
    const key = `${slideIndex}-${boxIndex}`;
    const measured = this.chartContainerWidths[key];
    if (measured && measured > 0) {
      return measured;
    }
    if (slide.slideType === 'splitContent') {
      return this.splitChartWidthFallback();
    }
    return this.containerWidth;
  }

  observeSplitBoxes(): void {
    if (this.splitBoxResizeObserver) {
      this.splitBoxResizeObserver.disconnect();
      this.splitBoxResizeObserver = null;
    }
    const presentation = document.getElementById('presentation');
    if (!presentation) {
      return;
    }
    const splitBoxes = presentation.querySelectorAll('.split-box');
    if (!splitBoxes.length) {
      return;
    }
    this.splitBoxResizeObserver = new ResizeObserver(() => {
      this.measureSplitChartContainerWidths();
    });
    splitBoxes.forEach((box) => {
      this.splitBoxResizeObserver!.observe(box);
    });
  }

  measureSplitChartContainerWidths(): void {
    const widths: Record<string, number> = {};
    for (let slideIndex = 0; slideIndex < this.slides.length; slideIndex++) {
      const slide = this.slides[slideIndex];
      const slideEl = document.getElementById('slide' + (slideIndex + 1));
      if (!slideEl) {
        continue;
      }
      if (slide.slideType === 'splitContent') {
        const splitBoxes = slideEl.querySelectorAll('.split-box');
        splitBoxes.forEach((box, boxIndex) => {
          const chartContainer = box.querySelector(
            '.chart-container',
          ) as HTMLElement | null;
          const content = box.querySelector('.content') as HTMLElement | null;
          const el = chartContainer || content;
          if (el && el.clientWidth > 0) {
            widths[`${slideIndex}-${boxIndex}`] = el.clientWidth;
          }
        });
      } else if (
        slide.slideType === 'slideFullContent' ||
        slide.slideType === 'slideContent'
      ) {
        const chartContainers = slideEl.querySelectorAll(
          '.content .chart-container',
        );
        chartContainers.forEach((el, boxIndex) => {
          const htmlEl = el as HTMLElement;
          if (htmlEl.clientWidth > 0) {
            widths[`${slideIndex}-${boxIndex}`] = htmlEl.clientWidth;
          }
        });
      }
    }
    const keys = Object.keys(widths);
    if (keys.length === 0) {
      return;
    }
    let changed = keys.length !== Object.keys(this.chartContainerWidths).length;
    if (!changed) {
      for (const key of keys) {
        if (this.chartContainerWidths[key] !== widths[key]) {
          changed = true;
          break;
        }
      }
    }
    if (changed) {
      this.chartContainerWidths = widths;
    }
  }

  focusFirst() {
    const first: any = document.querySelector('.slide');
    if (!first) {
      return;
    }
    first.focus();
  }

  thisVersion() {
    if (process.env.VUE_APP_BRAND === 'GT') {
      return 'gt';
    }
    return 'demo';
  }

  chartType(chart: any) {
    return resolveChartType(chart);
  }

  isDocumentFullscreen(): boolean {
    const doc: any = document;
    return !!(
      doc.fullscreenElement ||
      doc.mozFullScreenElement ||
      doc.webkitFullscreenElement ||
      doc.msFullscreenElement
    );
  }

  async closeFullscreen() {
    const wasFullscreen = this.isDocumentFullscreen();
    const elem: any = document;
    if (elem.exitFullscreen) {
      elem.exitFullscreen();
    } else if (elem.mozCancelFullScreen) {
      /* Firefox */
      elem.mozCancelFullScreen();
    } else if (elem.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      elem.webkitExitFullscreen();
    } else if (elem.msExitFullscreen) {
      /* IE/Edge */
      elem.msExitFullscreen();
    }

    const route = this.$router && this.$router.currentRoute
      ? this.$router.currentRoute.name
      : '';
    if (this.mode === 'presentation' && route === 'presentation-deck') {
      if (!wasFullscreen) {
        await deck.save();
        this.$router.back();
      }
    }
  }

  get isPrint(): boolean {
    if (
      !this.$router ||
      !this.$router.currentRoute ||
      !this.$router.currentRoute.name
    ) {
      return false;
    }
    return this.$router.currentRoute.name.endsWith('print');
  }

  get background(): string {
    return deck.Background;
  }

  @Watch('companyData', { immediate: true, deep: true })
  onCompanyData() {
    this.version = deck.Data.version;
    this.$nextTick(() => {
      this.measureSplitChartContainerWidths();
      this.observeSplitBoxes();
    });
  }

  @Watch('currentSlide', { immediate: true, deep: true })
  onCurrentSlide() {
    const current = deck.Slides[this.currentSlide - 1];
    this.editable = !current || !current.comment;
    this.scrollIntoView();
    this.$nextTick(() => {
      this.measureSplitChartContainerWidths();
      this.observeSplitBoxes();
    });
  }

  @Watch('showComments', { immediate: true, deep: true })
  onShowComments() {
    this.open = this.showComments === true;
  }

  openSidepanel() {
    this.open = true;
    this.$emit('showComments', true);
  }

  closeSidepanel() {
    const current = deck.Slides[this.currentSlide - 1];
    this.editable = !current || !current.comment;
    this.open = false;
    this.$emit('showComments', false);
  }

  editComment() {
    this.editable = true;
  }

  resetComment() {
    deck.Slides[this.currentSlide - 1].comment = '';
  }

  openHelpPanel() {
    this.helpPanelOpen = this.checkHelpPanel();
  }

  checkHelpPanel() {
    if (
      !deck.Slides[deck.nav.currentSlide - 1].subSlides ||
      deck.Slides[deck.nav.currentSlide - 1].subSlides.length <
        deck.nav.currentSubSlide + 1
    ) {
      return false;
    }
    const content =
      deck.Slides[deck.nav.currentSlide - 1].subSlides[deck.nav.currentSubSlide]
        .chart;
    if (content === 'cash' || content === 'compass') {
      this.helpPanelContent = content;
      return true;
    }
    this.helpPanelContent = null;
    return false;
  }

  closeHelpPanel() {
    this.helpPanelOpen = false;
  }

  get lang() {
    return sv;
  }

  handleTouchStart(event: TouchEvent) {
    if (event.touches.length === 1) {
      this.touchStartY = event.touches[0].clientY;
    }
  }

  handleTouchEnd(event: TouchEvent) {
    if (event.changedTouches.length === 1) {
      const deltaY = event.changedTouches[0].clientY - this.touchStartY;
      if (Math.abs(deltaY) > 50) {
        if (deltaY > 0) {
          this.handleKey({ key: 'ArrowUp' });
        } else {
          this.handleKey({ key: 'ArrowDown' });
        }
      }
    }
  }

  private scrollIntoView() {
    const p = document.getElementById('slide' + this.currentSlide);
    if (!p) {
      return;
    }
    this.lastScrolledSlide = this.currentSlide;
    p.scrollIntoView({ behavior: 'smooth' });
  }
}
